<script lang="ts">
    import type { Component } from 'svelte';
    import type { InteractiveTitleInputDefinition } from '../types';
    import {
        InteractiveTitleSelect,
        InteractiveTitleSelectClearable,
        InteractiveTitleMultiSelect,
        InteractiveTitleNumber,
        InteractiveTitleStaticString,
        InteractiveTitleCurrentViewSelect,
    } from './interactiveTitleInputs';

    interface Props {
        field: InteractiveTitleInputDefinition;
    }

    let { field }: Props = $props();

    function getFieldComponent(
        fieldType: InteractiveTitleInputDefinition['type'],
    ): Component<Props> {
        switch (fieldType) {
            case 'Select':
            case 'SelectNumber':
                return InteractiveTitleSelect as unknown as Component<Props>;
            case 'SelectClearable':
            case 'SelectNumberClearable':
                return InteractiveTitleSelectClearable as unknown as Component<Props>;
            case 'MultiSelect':
                return InteractiveTitleMultiSelect as unknown as Component<Props>;
            case 'Number':
                return InteractiveTitleNumber as unknown as Component<Props>;
            case 'StaticString':
                return InteractiveTitleStaticString as unknown as Component<Props>;
            case 'SelectCurrentView':
                return InteractiveTitleCurrentViewSelect as unknown as Component<Props>;
        }
    }
</script>

<svelte:component this={getFieldComponent(field.type)} {field} on:change />
